import React from 'react'
import { Box, CircularProgress, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../AuthProvider'
import { useNavigate } from 'react-router-dom'

const RequireUser: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { authenticated, initialized, user } = useAuth()
  const { t } = useTranslation()
  const navigate = useNavigate()

  React.useEffect(() => {
    if (initialized && !authenticated) {
      // Redirect to login page (not callback to avoid loops)
      navigate('/login', { replace: true })
    }
  }, [initialized, authenticated, navigate])

  if (!initialized) {
    return (
      <Box sx={{ p: 4, textAlign: 'center' }}>
        <CircularProgress sx={{ mb: 2 }} />
        <Typography>{t('loading')}</Typography>
      </Box>
    )
  }

  if (!authenticated) {
    return (
      <Box sx={{ p: 4, textAlign: 'center' }}>
        <CircularProgress sx={{ mb: 2 }} />
        <Typography>{t('auth.redirectingToLogin', 'Redirecting to login...')}</Typography>
      </Box>
    )
  }

  return <>{children}</>
}

export default RequireUser

